import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export type BadgeTone = 'neutral' | 'info' | 'success' | 'danger';

const tones: Record<BadgeTone, string> = {
  neutral: 'bg-surface-muted text-ink-muted',
  info: 'bg-accent-soft text-accent-hover',
  success: 'bg-success-soft text-success-ink',
  danger: 'bg-danger-soft text-danger-ink',
};

type BadgeProps = { tone?: BadgeTone; mono?: boolean; className?: string; children: ReactNode };

export function Badge({ tone = 'neutral', mono = false, className, children }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center self-start rounded-sm px-2 py-1 text-xs leading-none',
        mono ? 'font-mono font-normal' : 'font-semibold',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
